const URL_PATTERN = /https?:\/\/[^\s"'<>]+/gu;

const redactUrlQueryString = (candidate: string): string => {
  try {
    const url = new URL(candidate);

    return `${url.origin}${url.pathname}`;
  } catch {
    return candidate;
  }
};

const redactUrlQueryStrings = (value: string): string => {
  let redactedValue = '';
  let lastIndex = 0;

  for (const match of value.matchAll(URL_PATTERN)) {
    const url = match[0];
    const index = match.index;

    redactedValue += value.slice(lastIndex, index);
    redactedValue += redactUrlQueryString(url);
    lastIndex = index + url.length;
  }

  return redactedValue + value.slice(lastIndex);
};

export default redactUrlQueryStrings;
